module.exports = __webpack_public_path__ + "static/media/blog-hai-prompt@3x.21564016.jpg";